/*eslint camelcase: ["error", {properties: "always"}]*/

import { axiosService } from '../.';

export default class GetOrganizationBusinessFrontPageSummaryByBusinessId {
    public async execute(businessId: number): Promise<GetOrganizationBusinessFrontPageSummaryByBusinessIdDto> {
        const frontPageSummay = (await axiosService.instance.get(`businesses/organization/front-page/${businessId}/summary`)).data;
        return new GetOrganizationBusinessFrontPageSummaryByBusinessIdDto(frontPageSummay);
    }
}

export class GetOrganizationBusinessFrontPageSummaryByBusinessIdDto {
    public readonly businessId: number = 0;
    public readonly publicationStatus: GetOrganizationBusinessFrontPageSummaryByBusinessIdPublicationStatusDto[] = [];
    public readonly images: GetOrganizationBusinessFrontPageSummaryByBusineesIdFrontPageImageDto[] = [];
    public readonly hasClaim: boolean = false;
    public readonly hasSubclaim: boolean = false;
    public readonly hasDescription: boolean = false;
    public readonly hasContactName: boolean = false;
    public readonly hasContactPhone: boolean = false;
    public readonly hasContactEmail: boolean = false;
    public readonly hasContactWebsite: boolean = false;
    public readonly hasContactAddress: boolean = false;
    public readonly slug?: string;
    public readonly isSlugOperational: boolean | null = null;
    public readonly imagesCount: number = 0;
    public readonly openingHours?: GetOrganizationBusinessFrontPageSummaryByBusineesIdFrontPageImageDto;
    public readonly hasHighlights: boolean = false;
    public readonly mainImageUrl: string = '';
    public readonly hasOtherLinks: boolean = false;

    constructor(data: any) {
        this.businessId = data.businessId;
        this.publicationStatus = data.publicationStatus.map((x: any) => new GetOrganizationBusinessFrontPageSummaryByBusinessIdPublicationStatusDto(x));
        this.hasClaim = data.hasClaim;
        this.hasSubclaim = data.hasSubclaim;
        this.hasDescription = data.hasDescription;
        this.hasContactName = data.hasContactName;
        this.hasContactPhone = data.hasContactPhone;
        this.hasContactEmail = data.hasContactEmail;
        this.hasContactWebsite = data.hasContactWebsite;
        this.slug = data.slug;
        this.isSlugOperational = data.isSlugOperational;
        this.hasContactAddress = data.hasContactAddress;
        this.imagesCount = data.imagesCount;
        this.openingHours = data.openingHours;
        this.hasHighlights = data.hasHighlights;
        if (data.mainImageUrl) {
            this.mainImageUrl = data.mainImageUrl;
        }
        this.hasOtherLinks = data.hasOtherLinks;
    }
}

export class GetOrganizationBusinessFrontPageSummaryByBusinessIdPublicationStatusDto {
    public readonly organizationId: number;
    public readonly consumerId: number;
    public readonly isCanonical: boolean;
    public readonly urlParts: GetOrganizationBusinessFrontPageSummaryByBusinessIdPublicationStatusConsumerAvailableUrlPartInfoDto[];
    public readonly isPublished: string;
    public readonly consumerName: string;

    constructor(data: any) {
        this.organizationId = data.organizationId;
        this.consumerId = data.consumerId;
        this.isCanonical = data.isCanonical;
        this.urlParts = data.urlParts.map((x: any) => new GetOrganizationBusinessFrontPageSummaryByBusinessIdPublicationStatusConsumerAvailableUrlPartInfoDto(x));
        this.isPublished = data.isPublished;
        this.consumerName = data.consumerName;
    }
}

export class GetOrganizationBusinessFrontPageSummaryByBusinessIdPublicationStatusConsumerAvailableUrlPartInfoDto {
    public readonly culture: string;
    public readonly urlForEntitiesWithSlug: string;
    public readonly urlForEntitiesWithoutSlug: string;

    constructor(data: any) {
        this.urlForEntitiesWithSlug = data.urlForEntitiesWithSlug;
        this.culture = data.culture;
        this.urlForEntitiesWithoutSlug = data.urlForEntitiesWithoutSlug;
    }
}

export class GetOrganizationBusinessFrontPageSummaryByBusineesIdFrontPageImageDto {
    public readonly type: number;
    public readonly url: string;

    constructor(data: any) {
        this.type = data.type;
        this.url = data.url;
    }
}

export const getOrganizationBusinessFrontPageSummaryByBusinessId = new GetOrganizationBusinessFrontPageSummaryByBusinessId();
